export default __webpack_public_path__ + "static/media/illustration-study-2-n-w@3x.012f1cf7.webp";